import { Checkbox, FormControlLabel } from '@mui/material';
import { FieldProps } from 'formik';

interface Props {
    label: string;
}

export default function LabeledCheckbox(props: FieldProps & Props) {
    const { field, form, label, ...otherProps } = props;

    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={field.value}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    name={field.name}
                    disabled={form.isSubmitting}
                />
            }
            label={label}
            {...otherProps}
        />
    );
}
